import { ActionRegistryCategory } from '../../../registry/action/ActionRegistryCategory';
import { ActionRegistryItem } from '../../../registry/action/ActionRegistryItem';
export class ActionsMultiSelectOption extends ActionRegistryCategory {
    label = 'SelectTask Option';
    constructor(parent) {
        super(parent);
        super.init();
    }
    selectSelectOption = () => new ActionRegistryItem({
        label: 'Select Option auswählen',
        action: ({ app, questionMultiSelect, multiSelectTask, option, event, e }) => {
            if (!questionMultiSelect || !option)
                return;
            if (app.appInfo.isUserCurrentlyEditing) {
                option.shouldBeSelected = !option.shouldBeSelected;
                return;
            }
            if (!multiSelectTask.taskProgress.isTaskComplete) {
                option.selectOption({ event });
                if (e)
                    e.stopPropagation();
                if (document.activeElement instanceof HTMLElement)
                    document.activeElement.blur();
                setTimeout(() => option.actorEvents.fireEvent({ type: 'optionwasselected' }));
            }
        },
    });
}
